import axios from 'axios';

const API_URL = 'http://137.74.92.81:3098';

export async function saveUserRecord(userId: number, level: number, time: number, gameId: number): Promise<boolean> {
    const url = API_URL + '/saveGameTime';
    const postData = {
        userId, level, time, gameId,
    };
    const data = await axios.post(url , postData);
    console.log(data);
    return data.data as boolean;
}